import * as action from 'actions'
import {call, put} from 'redux-saga/effects'
import * as actNotif from 'actions/notifications'
import * as api from 'api/sales'

/**
 * Fetch sales summary from the server
 * @param {object} params
 * @returns {*} sales from server, or false if the request fails
 */
export function * getSalesSummary (params) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.getSalesSummary, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

/**
 * Fetch sales summary from the server
 * @param {object} params
 * @returns {*} sales from server, or false if the request fails
 */
export function * getGrossProfit (params) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.getGrossProfit, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

/**
 * Fetch payment methods from the server
 * @param {object} params
 * @returns {*} payment methods from server, or false if the request fails
 */
export function * getPaymentMethods (params) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.getPaymentMethods, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

/**
 * Fetch item sales from the server
 * @param {object} params
 * @returns {*} item sales from server, or false if the request fails
 */
export function * getItemSales (params) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.getItemSales, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

/**
 * Fetch category sales from the server
 * @param {object} params
 * @returns {*} category sales from server, or false if the request fails
 */
export function * getCategorySales (params) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.getCategorySales, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

/**
 * Fetch modifier sales from the server
 * @param {object} params
 * @returns {*} modifier sales from server, or false if the request fails
 */
export function * getModifierSales (params) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.getModifierSales, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

/**
 * Fetch discounts from the server
 * @param {object} params
 * @returns {*} discounts from server, or false if the request fails
 */
export function * getDiscounts (params) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.getDiscounts, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

/**
 * Fetch taxes from the server
 * @param {object} params
 * @returns {*} taxes from server, or false if the request fails
 */
export function * getTaxes (params) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.getTaxes, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

/**
 * Fetch gratuity from the server
 * @param {object} params
 * @returns {*} gratuities from server, or false if the request fails
 */
export function * getGratuities (params) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.getGratuities, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

/**
 * Fetch staffs from the server
 * @param {object} params
 * @returns {*} staffs from server, or false if the request fails
 */
export function * getStaffs (params) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.getStaffs, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

/**
 * Fetch servers from the server
 * @param {object} params
 * @returns {*} servers from server, or false if the request fails
 */
export function * getServers (params) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.getServers, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}



// WEBPACK FOOTER //
// ./app/sagas/api/sales.js